import { render, staticRenderFns } from "./button.vue?vue&type=template&id=375c0767&scoped=true"
import script from "./button.vue?vue&type=script&lang=ts"
export * from "./button.vue?vue&type=script&lang=ts"
import style0 from "./button.vue?vue&type=style&index=0&id=375c0767&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375c0767",
  null
  
)

export default component.exports